import { create } from "zustand";
import faker from "faker";
import { decodeTokenService } from "../services/decodeTokenService";
import { vPagesUsersService } from "../services/vfPages/";
import { WebsiteDeleteResponse } from "../interfaces/websites";
import { Website, WebsitesState } from "../interfaces/websites";
import { WebsiteType, WebsiteStatus } from "../types/websites";
import { getListOfFiles } from "../services/generativeAI/generativeAIAxios/generateCopysAxios";

const fetchWebsites = async (): Promise<Website[]> => {
  // const userEmail = decodeTokenService.getEmailFromToken();
  // if (!userEmail) return []

  try {
    const userId = decodeTokenService.getUserIdFromToken() || "";
    const websitesData = await getListOfFiles();
    const websitesWithUrls = await Promise.all(
      websitesData
        // .filter((site: any) => {
        //   return site.status === "PUBLISH";
        // })
        .map(async (site: any) => {
          try {
            return {
              userId: userId,
              projectId: "",
              websiteId: site.id.toString(),
              name: site.brand_name,
              productName: site.name,
              type: (site.type as WebsiteType) || "Landing Page",
              status: "Online" as WebsiteStatus,
              url: site.url,
              sales_angle: site.sale_angle.name,
              sales_angle_description: site.sale_angle.description,
              visits: 0,
              products: site.products,
              conversionRate: 0,
              theme: "Default Theme",
              lastEdited: new Date(site.updated_at).toISOString(),
              createdAt: new Date(site.created_at).toISOString(),
              configurations: site.configurations,
              idSequence: site.id_sequence_owner_id,
            };
          } catch (error) {
            console.error("Error processing site:", site, error);
            throw error;
          }
        })
    );

    return websitesWithUrls;
  } catch (error) {
    console.error("Error fetching funnels:", error);
    return [];
  }
};

export const useWebsitesStore = create<WebsitesState>((set) => ({
  projectId: null,
  websites: [],
  tempChanges: {},
  hasChanges: false,
  userId: null,
  isLoading: false,

  addWebsite: (website) =>
    set((state) => ({
      websites: [
        ...state.websites,
        {
          ...website,
          id: faker.datatype.uuid(),
          createdAt: new Date().toISOString(),
          lastEdited: new Date().toISOString(),
        },
      ],
      hasChanges: true,
    })),
  deleteWebsite: async (id) => {
    try {
      // Llamada al servicio para eliminar el sitio web
      const userId = decodeTokenService.getUserIdFromToken() || "";

      const response: WebsiteDeleteResponse =
        await vPagesUsersService.deleteWebsite(userId, id);
      // if (response.success) {
      //   set((state) => ({
      //     websites: state.websites.filter(
      //       (website) => website.websiteId !== id
      //     ),
      //     hasChanges: true,
      //   }));
      // } else {
      //   throw new Error("Error al eliminar el sitio web");
      // }
      return "";
    } catch (error) {
      console.error("Error al eliminar el sitio web:", error);
      throw error; // Re-lanzamos el error para manejarlo en el componente
    }
  },
  setTempChanges: (changes) =>
    set(() => ({
      tempChanges: changes,
      hasChanges: Object.keys(changes).length > 0,
    })),
  saveChanges: () =>
    set((state) => {
      const updatedWebsites = state.websites.map((website) => ({
        ...website,
        ...state.tempChanges[website.websiteId],
        lastEdited: new Date().toISOString(),
      }));

      return {
        websites: updatedWebsites,
        tempChanges: {},
        hasChanges: false,
      };
    }),
  discardChanges: () =>
    set({
      websites: [],
      tempChanges: {},
      hasChanges: false,
    }),

  initialize: async () => {
    set({ isLoading: true });
    try {
      const userId = decodeTokenService.getUserIdFromToken() || "";
      const websites = await fetchWebsites();
      set({
        userId,
        websites,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error initializing user:", error);
      set({ isLoading: false });
    }
  },

  projectActive: async () => {
    // const userId = await userActive();
    // const userId = decodeTokenService.getUserIdFromToken() || "";
    // if (!userId) throw new Error("Usuario no encontrado");
    // const projectId = await projectActive(userId);
    // if (!projectId) throw new Error("Proyecto no encontrado");
    return "";
  },
}));
